import React from 'react';

export default class AddTenantModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant: this.props.tenant,
      usePropertyAddress: false,
      searchData: [],
      searchFocus: false,
      existingTenant: false,
      allowOnlineAccess: this.props.allowOnlineAccess,
    };
    this.unsetStyle = {
      position: 'unset',
    };

    this.blankAddress = this.props.tenant.address_attributes;
    this._handleCancel = this._handleCancel.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
    this._handleSearch = this._handleSearch.bind(this);
    this._makeTextField = this._makeTextField.bind(this);
    this._handleTextFieldChange = this._handleTextFieldChange.bind(this);
    this._handleCustomFieldChange = this._handleCustomFieldChange.bind(this);
    this._handleCustomCheckboxChange =
      this._handleCustomCheckboxChange.bind(this);
    this._handleUsePropertyAddress = this._handleUsePropertyAddress.bind(this);
    this.onlineAccessOnClick = this.onlineAccessOnClick.bind(this);
    this._makeSelectMenu = this._makeSelectMenu.bind(this);
    this._makeCountriesSelectMenu = this._makeCountriesSelectMenu.bind(this);
    this._makeStatesSelectMenu = this._makeStatesSelectMenu.bind(this);
    this._makeRolesSelectMenu = this._makeRolesSelectMenu.bind(this);
    this._makeTenantRolesSelectMenu =
      this._makeTenantRolesSelectMenu.bind(this);
    this._handleSelectChange = this._handleSelectChange.bind(this);
    this._onSearchFocus = this._onSearchFocus.bind(this);
    this._onSearchBlur = this._onSearchBlur.bind(this);
    this._existingEntitySelect = this._existingEntitySelect.bind(this);
    this._clearTenantInfo = this._clearTenantInfo.bind(this);
    this.handleGroupHeaderClick = this.handleGroupHeaderClick.bind(this);
  }

  componentWillMount() {
    this.timer = null;
  }

  componentDidMount() {
    var _tenant = deepCopyObject(this.state.tenant);
    _tenant['tenant_lease_relationships_attributes'][0]['tenant_role_id'] =
      $('#tenant-role').val();
    _tenant['tenant_lease_relationships_attributes'][0][
      'license_role_tenant_lease_relationship_attributes'
    ]['license_role_id'] = $('#tenant-license-role').val();
    _tenant['address_attributes']['country'] = $('#address-country').val();
    _tenant['address_attributes']['state'] = $('#address-state').val();
    this.setState({ tenant: _tenant });
    initReactSelect2(
      '#mdc-dialog-add-tenant .pm-default-select2-menu',
      this._handleSelectChange
    );
    initReactDatepicker(
      '#mdc-dialog-add-tenant .custom-field-groups-panel .pm-datepicker-field',
      this._handleCustomFieldChange
    );
    initReactDateTimepicker(
      '#mdc-dialog-add-tenant .custom-field-groups-panel .pm-datetimepicker-field',
      this._handleCustomFieldChange
    );
    initReactTimepicker(
      '#mdc-dialog-add-tenant .custom-field-groups-panel .pm-timepicker-field',
      this._handleCustomFieldChange
    );
  }

  componentDidUpdate() {
    $('select', '#mdc-dialog-add-tenant').each(function () {
      $(this).trigger('change');
      $(this).select2();
    });
  }

  _handleSubmit(event) {
    startLoadingSpinner('new-tenant-section');
    var submitBtn = event.target;
    var that = this;
    disableBtn(submitBtn);
    const handleSubmitCallback = (tenantInfo) => {
      $.ajax({
        url: '/entities/create_new_tenant_redesign',
        dataType: 'JSON',
        method: 'POST',
        data: {
          person: tenantInfo,
        },
        success: (data) => {
          if (data.errors !== '') {
            alert(data.errors);
          } else {
            this.props.onSubmit('mdc-dialog-add-tenant');
          }
        },
        error: function (data) {
          if (data.responseJSON != null && data.responseJSON.errors != null)
            alert(data.responseJSON.errors);
        },
        complete: function () {
          enableSubmit(submitBtn);
          stopLoadingSpinner('new-tenant-section');
        },
      });
    };
    var tenantInfo;
    if (this.state.existingTenant) {
      tenantInfo = {
        tenant_lease_relationships_attributes: [
          {
            lease_id:
              this.state.tenant.tenant_lease_relationships_attributes[0]
                .lease_id,
            tenant_role_id:
              this.state.tenant['tenant_lease_relationships_attributes'][0][
                'tenant_role_id'
              ],
            license_role_tenant_lease_relationship_attributes: {
              license_role_id:
                this.state.tenant['tenant_lease_relationships_attributes'][0][
                  'license_role_tenant_lease_relationship_attributes'
                ]['license_role_id'],
            },
            allow_online_access:
              this.state.tenant['tenant_lease_relationships_attributes'][0][
                'allow_online_access'
              ],
          },
        ],
        id: this.state.tenant.id,
      };
      handleSubmitCallback(tenantInfo);
    } else {
      tenantInfo = deepCopyObject(that.state.tenant);
      // TODO: check that required custom fields have data
      var customFieldsArr = [];

      Object.entries(
        that.state.tenant.tenant_role_relationship_attributes
          .custom_fields_attributes
      ).forEach(([k, v]) => {
        v.forEach((cf) => {
          customFieldsArr.push(cf);
        });
      });

      var customFields = customFieldsArr.map((field) => {
        return {
          value: field.value,
          custom_field_type_id:
            field.custom_field_type != null
              ? field.custom_field_type.id
              : field.custom_field_type_id,
        };
      });
      delete tenantInfo['custom_field_type_groups'];
      tenantInfo.tenant_role_relationship_attributes.custom_fields_attributes =
        customFields;
      if (
        !that.state.allowOnlineAccess &&
        that.state.tenant.phone !== '' &&
        that.state.tenant.email === ''
      ) {
        confirm(
          'Would you like to send an invite text to the tenant? This allows them to log in to their tenant portal.',
          function (ok) {
            if (ok) {
              tenantInfo.tenant_lease_relationships_attributes[0].allow_online_access = true;
              handleSubmitCallback(tenantInfo);
            } else {
              handleSubmitCallback(tenantInfo);
            }
          }
        );
      } else {
        handleSubmitCallback(tenantInfo);
      }
    }
  }

  _handleCancel() {
    this.props.onCancel('mdc-dialog-add-tenant');
  }

  _handleUsePropertyAddress() {
    var _tenant = deepCopyObject(this.state.tenant);
    var address = !this.state.usePropertyAddress
      ? this.props.lease_address
      : this.blankAddress;
    _tenant['address_attributes'] = address;
    this.setState({
      usePropertyAddress: !this.state.usePropertyAddress,
      tenant: _tenant,
    });
  }
  onlineAccessOnClick() {
    const tempTenant = deepCopyObject(this.state.tenant);
    tempTenant.tenant_lease_relationships_attributes[0].allow_online_access =
      !this.state.allowOnlineAccess;
    this.setState({
      allowOnlineAccess: !this.state.allowOnlineAccess,
      tenant: tempTenant,
    });
  }

  handleGroupHeaderClick(e) {
    $(e.target).parents('.mdc-expansion').toggleClass('closed');
    $(e.target).parents('.mdc-expansion').toggleClass('open');
    reinitExpansionHeight(document.getElementById('mdc-dialog-add-tenant'));
  }

  _makeTextField(attribute, value, label, disabled = false, search = false) {
    var onChangeFunction = search
      ? this._handleSearch
      : this._handleTextFieldChange;
    return (
      <div className="pm-flex pm-flex-col">
        <div className="mdc-form-field mdc-form-field--align-end">
          <div
            className="mdc-text-field pm-margin-none mdc-text-field--upgraded"
            data-mdc-auto-init="MDCTextField"
          >
            <input
              type="text"
              className="mdc-text-field__input"
              id={attribute}
              name={attribute}
              value={value}
              onChange={onChangeFunction}
              disabled={disabled}
              onFocus={search ? this._onSearchFocus : ''}
              onBlur={search ? this._onSearchBlur : ''}
            />
            <label
              htmlFor={attribute}
              className={
                'mdc-floating-label ' +
                (value ? 'mdc-floating-label--float-above' : '')
              }
            >
              {label}
            </label>
            {attribute == 'firstname' && (
              <div
                id="autocomplete_spinner"
                style={{
                  position: 'absolute',
                  right: '0',
                  bottom: '0.3125rem',
                }}
              ></div>
            )}
          </div>
        </div>
      </div>
    );
  }
  _getSearchResults() {
    var searchResults = <div></div>;
    var searchResultsClass = 'mdc-menu mdc-select__menu';
    if (this.state.searchFocus && this.state.searchData.length > 0) {
      searchResultsClass += ' mdc-menu--open';
      searchResults = this.state.searchData.map((person, index) => {
        return (
          <li
            className="mdc-list-item"
            role="option"
            onMouseDown={this._existingEntitySelect}
            key={person.id}
            id={index}
          >
            {person.label}
          </li>
        );
      });
    }
    return (
      <div
        className={searchResultsClass}
        style={{
          position: 'relative',
          minHeight: 'unset',
          maxHeight: '25vh',
          marginTop: '2.5rem',
          marginBottom: '-3.75rem',
          width: '100vw',
          overflow: 'scroll',
        }}
      >
        <ul className="mdc-list mdc-menu__items ">{searchResults}</ul>
      </div>
    );
  }
  _existingEntitySelect(event) {
    var _person = this.state.searchData[event.target.id];
    var _tenant = deepCopyObject(this.state.tenant);
    _tenant['id'] = _person.id;
    _tenant['firstname'] = _person.firstname !== null ? _person.firstname : '';
    _tenant['mi'] = _person.mi !== null ? _person.mi : '';
    _tenant['lastname'] = _person.lastname !== null ? _person.lastname : '';
    _tenant['address_attributes']['addressline1'] =
      _person.addressline1 !== null ? _person.addressline1 : '';
    _tenant['address_attributes']['addressline2'] =
      _person.addressline2 !== null ? _person.addressline2 : '';
    _tenant['address_attributes']['city'] =
      _person.city !== null ? _person.city : '';
    _tenant['address_attributes']['state'] =
      _person.state !== null ? _person.state : '';
    _tenant['address_attributes']['country'] =
      _person.country !== null ? _person.country : '';
    _tenant['email'] = _person.email !== null ? _person.email : '';
    _tenant['phone'] = _person.phone !== null ? _person.phone : '';

    var customFields = {};
    if (Object.keys(_person.custom_fields).length > 0) {
      // Object.entries(_person.custom_fields){}
      for (var key in _person.custom_fields) {
        var cf = _person.custom_fields[key];
        var formatted_cf = {
          custom_field_type: {
            custom_field_type_group_id: cf.group_id,
            custom_field_values: [cf.value],
            field_type: cf.custom_field_type.field_type,
            hidden: cf.custom_field_type.hidden,
            id: cf.custom_field_type.id,
            name: cf.custom_field_type.name,
            requirement_option: cf.custom_field_type.requirement_option,
          },
          value: cf.value,
        };
        if (Object.keys(customFields).includes(cf.group_id.toString())) {
          customFields[cf.group_id.toString()].push(formatted_cf);
        } else {
          customFields[cf.group_id.toString()] = [formatted_cf];
        }
      }
    }

    _tenant['tenant_role_relationship_attributes']['custom_fields_attributes'] =
      customFields;

    this.setState({
      searchData: [],
      existingTenant: true,
      tenant: _tenant,
    });
  }
  _handleTextFieldChange(event) {
    var _tenant = deepCopyObject(this.state.tenant);
    if (event.target.id.includes('address')) {
      var attribute = event.target.id.split('-')[1];
      _tenant['address_attributes'][attribute] = event.target.value;
    } else {
      _tenant[event.target.id] = event.target.value;
    }
    this.setState({ tenant: _tenant });
  }
  _handleSearch(event) {
    clearTimeout(this.timer);
    var targetID = event.target.id;
    var targetValue = event.target.value;
    startLoadingSpinner('autocomplete_spinner');
    var _tenant = deepCopyObject(this.state.tenant);
    _tenant[targetID] = targetValue;
    this.setState({ tenant: _tenant });

    this.timer = setTimeout(() => {
      $.ajax({
        url: '/entities/role_search',
        dataType: 'JSON',
        method: 'GET',
        data: {
          q: targetValue,
          role: 'tenant',
          limit: 20,
        },
        success: (data) => {
          this.setState({ searchData: data });
        },
        complete: function () {
          stopLoadingSpinner('autocomplete_spinner');
        },
      });
    }, 500);
  }
  _onSearchFocus() {
    this.setState({ searchFocus: true });
  }
  _onSearchBlur() {
    this.setState({ searchFocus: false });
  }
  _clearTenantInfo() {
    let initialLicenseRoleValue = null;
    if (
      this.props.tenantLicenseRoles != null &&
      this.props.tenantLicenseRoles.length > 0
    ) {
      initialLicenseRoleValue = this.props.tenantLicenseRoles[0][1];
    }

    let customFieldsArr =
      this.state.tenant.tenant_role_relationship_attributes
        .custom_fields_attributes;

    Object.entries(customFieldsArr).forEach(([k, v]) => {
      v.map((cf) => {
        cf.value = '';
        cf.custom_field_type.custom_field_values = [];
      });
    });

    var blankTenant = {
      id: '',
      firstname: '',
      mi: '',
      lastname: '',
      address_attributes: {
        addressline1: '',
        addressline2: '',
        city: '',
        zipcode: '',
        state: 'AL',
        country: 'USA',
      },
      email: '',
      phone: '',
      tenant_lease_relationships_attributes: [
        {
          lease_id:
            this.state.tenant.tenant_lease_relationships_attributes[0].lease_id,
          tenant_role_id:
            this.state.tenant.tenant_lease_relationships_attributes[0]
              .tenant_role_id,
          license_role_tenant_lease_relationship_attributes: {
            license_role_id: initialLicenseRoleValue,
          },
        },
      ],
      tenant_role_relationship_attributes: {
        custom_fields_attributes: customFieldsArr,
      },
      custom_field_type_groups: this.state.tenant.custom_field_type_groups,
      // TODO: clear custom fields
    };
    this.setState({
      tenant: blankTenant,
      usePropertyAddress: false,
      searchData: [],
      existingTenant: false,
    });
  }
  _makeCountriesSelectMenu() {
    var countries = this.props.countries.map((country) => {
      return [country, country];
    });
    var countryExists =
      this.state.tenant.address_attributes.country !== undefined &&
      this.state.tenant.address_attributes.country !== null;
    var initialValue = countryExists
      ? this.state.tenant.address_attributes.country
      : countries[0][1];
    return (
      <div>
        {this._makeSelectMenu(
          'address-country',
          'Country',
          countries,
          initialValue,
          this.state.usePropertyAddress || this.state.existingTenant
        )}
      </div>
    );
  }
  _makeStatesSelectMenu() {
    var states = [];
    var countryExists =
      this.state.tenant.address_attributes.country !== undefined &&
      this.state.tenant.address_attributes.country !== null &&
      this.state.tenant.address_attributes.country !== '';
    var country = countryExists
      ? this.state.tenant.address_attributes.country
      : 'USA';
    Object.keys(this.props.countries_and_states[country]).forEach((key) => {
      var value = this.props.countries_and_states[country][key];
      states.push([value, value]);
    }, this);
    var initialValue =
      this.state.tenant.address_attributes.state !== ''
        ? this.state.tenant.address_attributes.state
        : states[0][1];
    var stateName = country === 'USA' ? 'State' : 'Province';
    return (
      <div>
        {this._makeSelectMenu(
          'address-state',
          stateName,
          states,
          initialValue,
          this.state.usePropertyAddress || this.state.existingTenant
        )}
      </div>
    );
  }
  _makeRolesSelectMenu() {
    var roles = this.props.roles.map((role) => {
      return [role.name, role.id];
    });
    var initialValue =
      this.state.tenant.tenant_lease_relationships_attributes.tenant_role_id !==
      null
        ? this.state.tenant.tenant_lease_relationships_attributes.tenant_role_id
        : roles[0][1];
    return (
      <div>
        {this._makeSelectMenu('tenant-role', 'Role', roles, initialValue)}
      </div>
    );
  }

  _makeTenantRolesSelectMenu() {
    let initialValue =
      this.state.tenant['tenant_lease_relationships_attributes'][0][
        'license_role_tenant_lease_relationship_attributes'
      ]['license_role_id'] !== null
        ? this.state.tenant['tenant_lease_relationships_attributes'][0][
            'license_role_tenant_lease_relationship_attributes'
          ]['license_role_id']
        : null;
    if (
      initialValue == null &&
      this.props.tenantLicenseRoles != null &&
      this.props.tenantLicenseRoles.length > 0
    ) {
      initialValue = this.props.tenantLicenseRoles[0][1];
    }

    return (
      <div>
        {this._makeSelectMenu(
          'tenant-license-role',
          `${this.props.getTermOverride('tenant', true)} Role`,
          this.props.tenantLicenseRoles,
          initialValue
        )}
      </div>
    );
  }

  _makeSelectMenu(
    attribute,
    label,
    optionsArray,
    initialValue,
    disabled = false,
    customName = null
  ) {
    // optionsArray formatted like so: [[name, value], [name, value]]
    var options = optionsArray.map((option, index) => {
      return (
        <option className="mdc-list-item" value={option[1]} key={index}>
          {option[0]}
        </option>
      );
    });
    return (
      <div className="pm-flex pm-flex-col">
        <div className="pm-select" role="listbox" tabIndex="0">
          <label>{label}</label>
          <select
            className="pm-default-select2-menu mdc-select"
            value={initialValue}
            onChange={this._handleSelectChange}
            id={attribute}
            style={{
              display: 'block',
              backgroundColor: 'transparent',
              marginTop: '0rem',
            }}
            name={customName ? customName : label}
            disabled={disabled}
          >
            {options}
          </select>
        </div>
      </div>
    );
  }

  _handleSelectChange(event) {
    var _tenant = deepCopyObject(this.state.tenant);
    var target = event.currentTarget;
    if (target.id.includes('address')) {
      var attribute = target.id.split('-')[1];
      _tenant['address_attributes'][attribute] = target.value;
    } else if (target.id === 'tenant-role') {
      _tenant['tenant_lease_relationships_attributes'][0]['tenant_role_id'] =
        target.value;
    } else if (target.id === 'tenant-license-role') {
      _tenant['tenant_lease_relationships_attributes'][0][
        'license_role_tenant_lease_relationship_attributes'
      ]['license_role_id'] = target.value;
    } else if (target.id.includes('custom')) {
      var customFieldTypeId = target.id.split('-').slice(-1)[0];

      let customFieldsArr =
        _tenant.tenant_role_relationship_attributes.custom_fields_attributes;
      Object.entries(customFieldsArr).forEach(([k, v]) => {
        v.forEach((cf) => {
          if (cf.custom_field_type.id === parseInt(customFieldTypeId)) {
            cf.value = target.value;
          }
        });
      });
    }

    this.setState({ tenant: _tenant });
  }

  _handleCustomFieldChange(event) {
    var _tenant = deepCopyObject(this.state.tenant);
    let customFieldsArr =
      _tenant.tenant_role_relationship_attributes.custom_fields_attributes;

    Object.entries(customFieldsArr).forEach(([k, v]) => {
      v.forEach((cf) => {
        if (
          cf.custom_field_type.id ===
          parseInt(
            event.currentTarget.getAttribute('data-custom-field-type-id')
          )
        ) {
          cf.value = event.currentTarget.value;
          cf.custom_field_type.custom_field_values = [
            event.currentTarget.value,
          ];
        }
      });
    });

    this.setState({ tenant: _tenant });
  }
  _handleCustomCheckboxChange(event) {
    var _tenant = deepCopyObject(this.state.tenant);
    var customFieldsArr =
      _tenant.tenant_role_relationship_attributes.custom_fields_attributes;

    Object.entries(customFieldsArr).forEach(([k, v]) => {
      v.forEach((cf) => {
        if (
          cf.custom_field_type.id ===
          parseInt(
            event.currentTarget.getAttribute('data-custom-field-type-id')
          )
        ) {
          cf.value = event.currentTarget.checked ? 'true' : 'false';
        }
      });
    });

    this.setState({ tenant: _tenant });
  }
  render() {
    var that = this;

    var firstName = this._makeTextField(
      'firstname',
      this.state.tenant.firstname,
      'First name',
      this.state.existingTenant,
      true
    );
    var middleinitial = this._makeTextField(
      'mi',
      this.state.tenant.mi,
      'Middle initial',
      this.state.existingTenant
    );
    var lastName = this._makeTextField(
      'lastname',
      this.state.tenant.lastname,
      'Last name',
      this.state.existingTenant
    );
    var searchResults = this._getSearchResults();
    var addressline1 = this._makeTextField(
      'address-addressline1',
      this.state.tenant.address_attributes.addressline1,
      'Address line 1',
      this.state.usePropertyAddress || this.state.existingTenant
    );
    var addressline2 = this._makeTextField(
      'address-addressline2',
      this.state.tenant.address_attributes.addressline2,
      'Address line 2',
      this.state.usePropertyAddress || this.state.existingTenant
    );
    var city = this._makeTextField(
      'address-city',
      this.state.tenant.address_attributes.city,
      'City',
      this.state.usePropertyAddress || this.state.existingTenant
    );
    var zipcode = this._makeTextField(
      'address-zipcode',
      this.state.tenant.address_attributes.zipcode,
      'Zipcode',
      this.state.usePropertyAddress || this.state.existingTenant
    );
    var country = this._makeCountriesSelectMenu();
    var state = this._makeStatesSelectMenu();
    var email = this._makeTextField(
      'email',
      this.state.tenant.email,
      'Email address',
      this.state.existingTenant
    );
    var phone = this._makeTextField(
      'phone',
      this.state.tenant.phone,
      'Phone number',
      this.state.existingTenant
    );
    var role = this._makeRolesSelectMenu();
    var tenantRole = this._makeTenantRolesSelectMenu();

    var customFieldGroups = [];

    var tmpCustomFields = $.extend(
      true,
      {},
      this.state.tenant.tenant_role_relationship_attributes
        .custom_fields_attributes
    );

    var customFields;
    var startIndex = 0;
    Object.keys(tmpCustomFields).forEach(function (key, idx) {
      var fields = tmpCustomFields[key];
      customFields = fields.map(function (field, index) {
        if (!field.custom_field_type.hidden) {
          var fieldIndex = startIndex + index;
          var requiredField =
            field.custom_field_type.requirement_option !=
            that.props.requirement_options_never;
          switch (field.custom_field_type.field_type) {
            case 'text':
              return (
                <div
                  className={`pm-flex pm-flex-col pm-margin-bottom-20 ${
                    requiredField ? 'required_field' : ''
                  }`}
                  key={field.custom_field_type.id}
                >
                  <div className="mdc-form-field mdc-form-field--align-end">
                    <div className="mdc-text-field pm-large pm-margin-none">
                      <label
                        htmlFor={`custom_field_${field.custom_field_type.id}`}
                        className="mdc-floating-label mdc-floating-label--float-above"
                        style={that.unsetStyle}
                      >
                        {field.custom_field_type.name}
                      </label>
                      <div className="pm-flex pm-flex-align-center">
                        <input
                          type="text"
                          disabled={that.state.existingTenant}
                          className="mdc-text-field__input"
                          id={`custom_field_${field.custom_field_type.id}`}
                          name={`person[tenant_role_relationship_attributes][custom_fields_attributes][${fieldIndex}][value]`}
                          data-custom-field-type-id={field.custom_field_type.id}
                          value={field.value}
                          onChange={that._handleCustomFieldChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
              break;
            case 'currency':
              return (
                <div
                  className={`pm-flex pm-flex-col pm-margin-bottom-20 ${
                    requiredField ? 'required_field' : ''
                  }`}
                  key={field.custom_field_type.id}
                >
                  <div className="mdc-form-field mdc-form-field--align-end">
                    <div className="mdc-text-field pm-large pm-margin-none">
                      <label
                        htmlFor={`custom_field_${field.custom_field_type.id}`}
                        className="mdc-floating-label mdc-floating-label--float-above"
                        style={that.unsetStyle}
                      >
                        {field.custom_field_type.name}
                      </label>
                      <div className="pm-flex pm-flex-align-center">
                        <input
                          type="text"
                          disabled={that.state.existingTenant}
                          className="mdc-text-field__input currency_field"
                          id={`custom_field_${field.custom_field_type.id}`}
                          name={`person[tenant_role_relationship_attributes][custom_fields_attributes][${fieldIndex}][value]`}
                          data-custom-field-type-id={field.custom_field_type.id}
                          value={field.value}
                          onChange={that._handleCustomFieldChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
              break;
            case 'number':
              return (
                <div
                  className={`pm-flex pm-flex-col pm-margin-bottom-20 ${
                    requiredField ? 'required_field' : ''
                  }`}
                  key={field.custom_field_type.id}
                >
                  <div className="mdc-form-field mdc-form-field--align-end">
                    <div className="mdc-text-field pm-large pm-margin-none">
                      <label
                        htmlFor={`custom_field_${field.custom_field_type.id}`}
                        className="mdc-floating-label mdc-floating-label--float-above"
                        style={that.unsetStyle}
                      >
                        {field.custom_field_type.name}
                      </label>
                      <div className="pm-flex pm-flex-align-center">
                        <input
                          type="number"
                          disabled={that.state.existingTenant}
                          className="mdc-text-field__input"
                          id={`custom_field_${field.custom_field_type.id}`}
                          name={`person[tenant_role_relationship_attributes][custom_fields_attributes][${fieldIndex}][value]`}
                          data-custom-field-type-id={field.custom_field_type.id}
                          value={field.value}
                          onChange={that._handleCustomFieldChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
              break;
            case 'date':
              return (
                <div
                  className={`pm-flex pm-flex-col pm-margin-bottom-20 ${
                    requiredField ? 'required_field' : ''
                  }`}
                  key={field.custom_field_type.id}
                >
                  <div className="mdc-form-field mdc-form-field--align-end">
                    <div className="mdc-text-field pm-large pm-margin-none">
                      <label
                        htmlFor={`custom_field_${field.custom_field_type.id}`}
                        className="mdc-floating-label mdc-floating-label--float-above"
                        style={that.unsetStyle}
                      >
                        {field.custom_field_type.name}
                      </label>
                      <div className="pm-flex pm-flex-align-center">
                        <input
                          type="text"
                          disabled={that.state.existingTenant}
                          className="mdc-text-field__input pm-datepicker-field"
                          id={`custom_field_${field.custom_field_type.id}`}
                          name={`person[tenant_role_relationship_attributes][custom_fields_attributes][${fieldIndex}][value]`}
                          data-custom-field-type-id={field.custom_field_type.id}
                          value={field.value}
                          onChange={that._handleCustomFieldChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
              break;
            case 'date / time':
              return (
                <div
                  className={`pm-flex pm-flex-col pm-margin-bottom-20 ${
                    requiredField ? 'required_field' : ''
                  }`}
                  key={field.custom_field_type.id}
                >
                  <div className="mdc-form-field mdc-form-field--align-end">
                    <div className="mdc-text-field pm-large pm-margin-none">
                      <label
                        htmlFor={`custom_field_${field.custom_field_type.id}`}
                        className="mdc-floating-label mdc-floating-label--float-above"
                        style={that.unsetStyle}
                      >
                        {field.custom_field_type.name}
                      </label>
                      <div className="pm-flex pm-flex-align-center">
                        <input
                          type="text"
                          disabled={that.state.existingTenant}
                          className="mdc-text-field__input pm-datetimepicker-field"
                          id={`custom_field_${field.custom_field_type.id}`}
                          name={`person[tenant_role_relationship_attributes][custom_fields_attributes][${fieldIndex}][value]`}
                          data-custom-field-type-id={field.custom_field_type.id}
                          value={field.value}
                          onChange={that._handleCustomFieldChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
              break;
            case 'time':
              return (
                <div
                  className={`pm-flex pm-flex-col pm-margin-bottom-20 ${
                    requiredField ? 'required_field' : ''
                  }`}
                  key={field.custom_field_type.id}
                >
                  <div className="mdc-form-field mdc-form-field--align-end">
                    <div className="mdc-text-field pm-large pm-margin-none">
                      <label
                        htmlFor={`custom_field_${field.custom_field_type.id}`}
                        className="mdc-floating-label mdc-floating-label--float-above"
                        style={that.unsetStyle}
                      >
                        {field.custom_field_type.name}
                      </label>
                      <div className="pm-flex pm-flex-align-center">
                        <input
                          type="text"
                          disabled={that.state.existingTenant}
                          className="mdc-text-field__input pm-timepicker-field"
                          id={`custom_field_${field.custom_field_type.id}`}
                          name={`person[tenant_role_relationship_attributes][custom_fields_attributes][${fieldIndex}][value]`}
                          data-custom-field-type-id={field.custom_field_type.id}
                          value={field.value}
                          onChange={that._handleCustomFieldChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
              break;
            case 'select':
              var customOptions =
                field.custom_field_type.custom_field_values.map((option) => {
                  return [option.value, option.value];
                });
              for (
                let i = 0;
                i < field.custom_field_type.custom_field_values.length;
                i++
              ) {
                if (
                  field.custom_field_type.custom_field_values[i].value ===
                  field.value
                ) {
                  var initialValue =
                    field.custom_field_type.custom_field_values[i].value;
                }
              }
              var customSelect = that._makeSelectMenu(
                `custom-${index}-${field.custom_field_type.id}`,
                field.custom_field_type.name,
                customOptions,
                initialValue,
                false,
                `person[tenant_role_relationship_attributes][custom_fields_attributes][${fieldIndex}][value]`
              );
              return (
                <div key={`${field.custom_field_type.name}_${index}`}>
                  {customSelect}
                </div>
              );
              break;
            case 'checkbox':
              var customChecked = field.value == 'true' || field.value == 'Yes';
              return (
                <div
                  className={`pm-flex pm-flex-col pm-margin-bottom-20 ${
                    requiredField ? 'required_field' : ''
                  }`}
                  key={`checkbox${field.custom_field_type.id}`}
                >
                  <label
                    className="mdc-floating-label mdc-floating-label--float-above"
                    style={that.unsetStyle}
                  >
                    {field.custom_field_type.name}
                  </label>
                  <div className="mdc-form-field" style={{ width: 'unset' }}>
                    <div
                      id="mdc-js-checkbox"
                      className="mdc-checkbox"
                      data-mdc-auto-init="MDCCheckbox"
                      style={{ marginRight: '-0.3125rem' }}
                    >
                      <input
                        disabled={that.state.existingTenant}
                        type="checkbox"
                        id={`checkbox${field.custom_field_type.id}`}
                        className="mdc-checkbox__native-control"
                        onChange={that._handleCustomCheckboxChange}
                        checked={customChecked}
                        name={`person[tenant_role_relationship_attributes][custom_fields_attributes][${fieldIndex}][value]`}
                        data-custom-field-type-id={field.custom_field_type.id}
                      />
                      <div className="mdc-checkbox__background">
                        <svg
                          className="mdc-checkbox__checkmark"
                          viewBox="0 0 24 24"
                        >
                          <path
                            className="mdc-checkbox__checkmark-path"
                            fill="none"
                            stroke="white"
                            d="M1.73,12.91 8.1,19.28 22.79,4.59"
                          />
                        </svg>
                        <div className="mdc-checkbox__mixedmark"></div>
                      </div>
                    </div>
                    <label
                      htmlFor={`checkbox${field.custom_field_type.id}`}
                      id="my-checkbox-label"
                      style={{ paddingRight: '0.25rem' }}
                    >
                      Enable
                    </label>
                  </div>
                </div>
              );
              break;
            case 'memo':
              return (
                <div
                  className={`pm-flex pm-flex-col pm-margin-bottom-20 ${
                    requiredField ? 'required_field' : ''
                  }`}
                  key={field.custom_field_type.id}
                >
                  <div className="mdc-form-field mdc-form-field--align-end">
                    <div
                      className="mdc-text-field mdc-text-field--multiline mdc-text-field--upgraded"
                      data-mdc-auto-init="MDCTextField"
                    >
                      <label
                        htmlFor={`customtextarea${field.custom_field_type.id}`}
                        className="mdc-floating-label mdc-floating-label--float-above"
                      >
                        {field.custom_field_type.name}
                      </label>
                      <textarea
                        id={`customtextarea${field.custom_field_type.id}`}
                        className="mdc-text-field__input"
                        rows="5"
                        cols="40"
                        value={field.value === null ? '' : field.value}
                        onChange={that._handleCustomFieldChange}
                        disabled={that.state.existingTenant}
                        name={`person[tenant_role_relationship_attributes][custom_fields_attributes][${fieldIndex}][value]`}
                        data-custom-field-type-id={field.custom_field_type.id}
                        style={{ paddingTop: '0.625rem' }}
                      ></textarea>
                    </div>
                  </div>
                </div>
              );
              break;
            default:
          }
        }
      });
      customFieldGroups.push(
        <div
          key={idx}
          id="custom-fields-panel"
          className="custom-field-groups-panel mdc-expansion-panel edit"
        >
          <div className="mdc-expansion closed">
            <div
              className="mdc-expansion__header group-header"
              onClick={that.handleGroupHeaderClick}
            >
              <span className="mdc-expansion__item">
                {that.state.tenant.custom_field_type_groups &&
                that.state.tenant.custom_field_type_groups[key]
                  ? that.state.tenant.custom_field_type_groups[key]
                  : that.props.getTermOverride('tenant', true)}
              </span>
              <div className="pm-flex-grow"></div>
            </div>
            <div id="custom-fields-panel__body" className="mdc-expansion__body">
              <div className="mdc-expansion__body--inner">
                <div
                  id="custom-fields-panel__content"
                  className="group-expansion-content mdc-expansion__content"
                >
                  <div
                    id="request-custom-fields-panel"
                    className="inner-custom-field-group-panel panel pm-flex"
                    style={{ paddingLeft: '4%' }}
                  >
                    <div
                      className="pm-flex pm-flex-2"
                      style={{ width: '100%', marginTop: '1.25rem' }}
                    >
                      {customFields}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
      startIndex += fields.length;
    });
    var customFieldHeader = <div></div>;
    if (
      this.state.tenant.tenant_role_relationship_attributes
        .custom_fields_attributes.length > 0
    ) {
      customFieldHeader = (
        <div>
          <hr></hr>
          <h3>Custom Fields</h3>
        </div>
      );
    }
    return (
      <aside
        id="mdc-dialog-add-tenant"
        className="mdc-dialog mdc-dialog--open"
        role="alertdialog"
        aria-hidden="true"
        aria-labelledby="mdc-dialog-default-label"
        aria-describedby="mdc-dialog-default-description"
      >
        <div className="mdc-dialog__surface" id="new-tenant-section">
          <header className="mdc-dialog__header pm-bg-color--blue1">
            <h2
              id="mdc-dialog-default-label"
              className="mdc-dialog__header__title"
            >
              Add {this.props.getTermOverride('tenant', true)}
            </h2>
          </header>
          <section
            id="mdc-dialog-default-description"
            className="mdc-dialog__body mdc-dialog__body--scrollable"
          >
            <h2>New {this.props.getTermOverride('tenant', true)}</h2>
            <div className="pm-flex pm-flex-3">
              {firstName}
              {middleinitial}
              {lastName}
              {searchResults}
            </div>
            <div
              className={this.state.existingTenant ? 'pm-flex pm-flex-2' : ''}
            >
              <div className="pm-flex pm-flex-2">
                <div className="pm-flex-col">
                  <div className="mdc-form-field">
                    <div
                      id="mdc-js-checkbox"
                      className="mdc-checkbox"
                      data-mdc-auto-init="MDCCheckbox"
                    >
                      <input
                        type="checkbox"
                        id="native-js-checkbox6"
                        className="mdc-checkbox__native-control"
                        checked={this.state.usePropertyAddress}
                        onChange={this._handleUsePropertyAddress}
                        disabled={this.state.existingTenant}
                      />
                      <div className="mdc-checkbox__background">
                        <svg
                          className="mdc-checkbox__checkmark"
                          viewBox="0 0 24 24"
                        >
                          <path
                            className="mdc-checkbox__checkmark-path"
                            fill="none"
                            stroke="white"
                            d="M1.73,12.91 8.1,19.28 22.79,4.59"
                          />
                        </svg>
                        <div className="mdc-checkbox__mixedmark"></div>
                      </div>
                    </div>
                    <label
                      htmlFor="native-js-checkbox6"
                      className="use_building_address"
                      id="my-checkbox-label"
                    >
                      Use Property Address
                    </label>
                  </div>
                </div>
                <div className="pm-flex-col">
                  <div className="mdc-form-field">
                    <div
                      id="mdc-js-checkbox"
                      className="mdc-checkbox"
                      data-mdc-auto-init="MDCCheckbox"
                    >
                      <input
                        type="checkbox"
                        id="native-js-checkbox7"
                        name="allow-online-access"
                        className="mdc-checkbox__native-control"
                        checked={this.state.allowOnlineAccess}
                        onChange={this.onlineAccessOnClick}
                      />
                      <div className="mdc-checkbox__background">
                        <svg
                          className="mdc-checkbox__checkmark"
                          viewBox="0 0 24 24"
                        >
                          <path
                            className="mdc-checkbox__checkmark-path"
                            fill="none"
                            stroke="white"
                            d="M1.73,12.91 8.1,19.28 22.79,4.59"
                          />
                        </svg>
                        <div className="mdc-checkbox__mixedmark"></div>
                      </div>
                    </div>
                    <label htmlFor="native-js-checkbox7" id="my-checkbox-label">
                      Allow Online Access
                    </label>
                  </div>
                </div>
              </div>
              {this.state.existingTenant && (
                <button
                  type="button"
                  className="mdc-button pm-text-color--red1 mdc-dialog__footer__button"
                  onClick={this._clearTenantInfo}
                >
                  Remove existing tenant information
                </button>
              )}
            </div>

            <div className="pm-flex pm-flex-2">
              {addressline1}
              {addressline2}
            </div>

            <div className="pm-flex pm-flex-2">
              {city}
              {zipcode}
            </div>

            <div className="pm-flex pm-flex-3">
              {country}
              {state}
              {tenantRole}
            </div>

            <div className="pm-flex pm-flex-3">
              {email}
              {phone}
              {role}
            </div>

            {customFieldHeader}
            {customFieldGroups}
          </section>
          <footer className="mdc-dialog__footer">
            <button
              type="button"
              className="cancel-button mdc-button pm-text-color--grey5 mdc-dialog__footer__button"
              data-testing-id="cancel"
              onClick={this._handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="save-button mdc-button pm-text-color--blue1 mdc-dialog__footer__button"
              data-testing-id="submit"
              onClick={this._handleSubmit}
            >
              Save
            </button>
          </footer>
        </div>
        <div className="mdc-dialog__backdrop"></div>
      </aside>
    );
  }
}
